var _polyline, _polyline2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleTransfrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    points: "9.4,8.2 17,8.2 17,5.3 22.4,10.6 17,15.7 17,12.7 8.1,12.7  "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    points: "14.2,12.7 6.6,12.7 6.6,9.7 1.2,15.1 6.6,20.2 6.6,17.2  15.6,17.2 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleTransfrIcon);
export default __webpack_public_path__ + "static/media/vehicle-transfr-icon.e3f71660ed12a610fb4409fa4abb82c8.svg";
export { ForwardRef as ReactComponent };